import { inject } from "@angular/core";
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { RootService } from "../services/root.service";

export const canActivateThankyou: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    let activated = inject(RootService).getIsThankyouRouteActiveValue();
    if (activated) {
      return true
    } else {
      inject(Router).navigate(['/']);
      return activated
    }
  };
